export const QUEUE_SOURCE_LABELS: Record<string, string> = {
  appointment_reminder_24h: 'Напоминание о записи (24 часа)',
  appointment_reminder_2h: 'Напоминание о записи (2 часа)',
  appointment_reminder_advance: 'Напоминание о записи (заранее)',
  appointment_reminder: 'Напоминание о записи (все: 24ч / 2ч / заранее)',
  appointment_changed: 'Изменение записи',
  appointment_cancelled: 'Отмена записи',
  appointment_completed: 'Завершение приёма',
  feedback_request: 'Сбор обратной связи',
  service_completed: 'Завершение услуги',
  birthday: 'День рождения',
  custom_trigger: 'Ручной триггер',
  scheduled_campaign: 'Плановая кампания',
  template_message: 'Шаблонное сообщение',
  cluster_followup: 'Кластерный follow-up',
  segment_schedule: 'Регулярная сегментная рассылка',
};

export const QUEUE_SOURCE_OPTIONS = Object.entries(QUEUE_SOURCE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export function getQueueSourceLabel(eventType?: string): string {
  return eventType ? QUEUE_SOURCE_LABELS[eventType] || eventType : '';
}

export function getQueueSourceLabelForQueueItem(item?: {
  event_type?: string;
  metadata?: Record<string, unknown>;
}): string {
  if (!item?.event_type) {
    return '';
  }

  const broadcastGroup = typeof item.metadata?.broadcast_group === 'string'
    ? item.metadata.broadcast_group.trim().toLowerCase()
    : '';

  if (broadcastGroup === 'reminder_24h') {
    return 'Напоминание о записи (24 часа)';
  }
  if (broadcastGroup === 'reminder_2h') {
    return 'Напоминание о записи (2 часа)';
  }
  if (broadcastGroup === 'reminder_advance') {
    return 'Напоминание о записи (заранее)';
  }
  if (broadcastGroup === 'segment_schedule') {
    return 'Регулярная сегментная рассылка';
  }

  const sourcePipeline = typeof item.metadata?.source_pipeline === 'string'
    ? item.metadata.source_pipeline.trim().toLowerCase()
    : '';
  if (sourcePipeline === 'segment_schedule') {
    return 'Регулярная сегментная рассылка';
  }

  return getQueueSourceLabel(item.event_type);
}
